import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CertificationArea, CertificationAreaResponse, CityCertificationResume, CityCertificationResumeAreas, Indicator } from 'app/shared/objects/certification';

@Component({
  selector: 'app-certification-iso-abnt-area',
  templateUrl: './certification-iso-abnt-area.component.html',
  styleUrls: ['./certification-iso-abnt-area.component.scss']
})
export class CertificationIsoAbntAreaComponent implements OnInit {

  @Input() cityCertificationResume: CityCertificationResumeAreas;
  @Output() begin = new EventEmitter<CertificationAreaResponse>();

  indicators: Indicator[];
  indicatorSelected: Indicator;

  certificationArea = CertificationArea;

  constructor() { }

  ngOnInit(): void {
    this.indicators = this.cityCertificationResume.indicators;
    this.indicatorSelected = this.indicators[0];
  }

  handleBegin(): void {
    this.begin.emit({
      resume: this.cityCertificationResume,
      indicator: this.indicatorSelected
    })
  }

  handleSelectIndicator(refCode: string) : void {
    this.indicatorSelected = this.indicators.find(indicator => indicator.refCode === refCode);
  }

  // sortIndicator(indicators): Indicator[] {
  //   if (indicators.length <= 1) {
  //     return indicators;
  //   }
  
  //   const pivot = indicators[0];
    
  //   const left = []; 
  //   const right = [];
  
  //   for (let i = 1; i < indicators.length; i++) {
  //     indicators[i].refCode < pivot.refCode ? left.push(indicators[i]) : right.push(indicators[i]);
  //   }
  
  //   return this.sortIndicator(left).concat(pivot, this.sortIndicator(right));
  // }

}
